<template>
  <div class="wt2-sg wt2-dashboard-navigation">
    <ul class="wt2-text-n" ref="tabs">
      <li
        v-for="(tab, i) in enabledNavigationTabs"
        :key="tab.path"
        @click.prevent="select(tab)"
        :class="[
          { '-selected': i === selectedIndex, '-newTab': tab.newTag },
          '-' + tab.label,
        ]"
      >
        <button :data-text="tab.label">
          {{ tab.label }}
          <div v-if="tab.newTag" class="-icon">New!</div>
        </button>
      </li>
    </ul>
    <aside ref="highlight"></aside>
  </div>
</template>

<script>
import app from 'app';
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardNavigation',
  data() {
    return {};
  },

  computed: {
    ...mapGetters('masthead', ['enabledNavigationTabs']),
    ...mapGetters(['routePath']),

    /**
     * get index of item that should be selected according to the routePath logic
     */
    // disable-tslint vue/no-async-in-computed-properties
    selectedIndex() {
      const i = _.findIndex(this.enabledNavigationTabs, (tab) => {
        return tab.path === this.routePath;
      });

      if (i >= 0) {
        // eslint-disable-next-line vue/no-async-in-computed-properties
        setTimeout(() => {
          this.$_updateHighlight(i);
        }, 128);
      }

      return i;
    },
  },

  methods: {
    select(tab) {
      const sameTab = this.routePath === tab.path;
      this.$store.dispatch('navigate', tab.path);

      if (sameTab) {
        // refresh page results
        if ('dashboard/inProgress' === tab.path) {
          this.$store.dispatch('fetchStories', { bReset: false });
        } else if ('dashboard/myVideos' === tab.path) {
          this.$store.dispatch('fetchVideos', { bReset: false });
        } else if ('dashboard/home' === tab.path) {
          this.$store.dispatch('fetchHomeStories');
          this.$store.dispatch('fetchHomeStoryboards');
        } else if ('dashboard/discover' === tab.path) {
          this.$store.dispatch('fetchReadyMadeVideos', { bReset: false });
        } else if ('dashboard/storyboards' === tab.path) {
          this.$store.dispatch('fetchStoryboards', {
            fetchMore: false,
            wochitTemplates: true,
          });
          this.$store.commit('setIndexOfSelectedStoryboard', -1);
          this.$store.commit('setIndexOfSelectedMyTeamStoryboard', -1);
        } else if ('dashboard/my-storyboards' === tab.path) {
          this.$store.dispatch('fetchStoryboards', {
            fetchMore: false,
            wochitTemplates: false,
          });
          this.$store.commit('setIndexOfSelectedStoryboard', -1);
          this.$store.commit('setIndexOfSelectedMyTeamStoryboard', -1);
        }
      } else {
        app.analytics('dashboard:navigation', { Page: tab.label });
      }
    },

    $_updateHighlight(i) {
      if (this._isDestroyed) {
        return;
      }
      const selectedEl = this.$refs.tabs.childNodes[i];
      const highlightEl = this.$refs.highlight;
      const width = selectedEl.clientWidth;
      const offset = selectedEl.offsetLeft;

      highlightEl.style.width = `${width}px`;
      highlightEl.style.transform = `translateX(${offset}px)`;
    },
  },
};
</script>
